import { useParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Edit } from "lucide-react";
import { useLensDetails } from "@/hooks/useLensDetails";
import { LensDetailsSkeleton } from "@/components/lens/LensDetailsSkeleton";
import { LensDetailsError } from "@/components/lens/LensDetailsError";
import { LensInfoCard } from "@/components/lens/LensInfoCard";
import { CompatibleCamerasSection } from "@/components/lens/CompatibleCamerasSection";
import { EditLensDialog } from "@/components/lens/EditLensDialog";

export default function LensDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  
  const {
    lens,
    compatibleCameras,
    loading,
    error,
    isEditDialogOpen,
    setIsEditDialogOpen,
    form,
    handleUpdateLens,
    fetchLensDetails
  } = useLensDetails(id);

  const handleBackClick = () => {
    navigate('/inventory?tab=lens');
  };

  const handleEditLens = () => {
    setIsEditDialogOpen(true);
  };

  if (loading) {
    return <LensDetailsSkeleton onBackClick={handleBackClick} />;
  }

  if (error || !lens) {
    return <LensDetailsError error={error} onBackClick={handleBackClick} />;
  }

  return (
    <div className="container py-6 space-y-6 max-w-[1200px] mx-auto">
      <div className="flex items-center justify-between gap-2 mb-6">
        <Button variant="outline" size="sm" onClick={handleBackClick}>
          <ArrowLeft className="h-4 w-4 mr-1" />
          Back to Lenses
        </Button>
        
        <Button onClick={handleEditLens} size="sm">
          <Edit className="h-4 w-4 mr-1" />
          Edit Lens
        </Button>
      </div>
      
      <EditLensDialog
        isOpen={isEditDialogOpen}
        setIsOpen={setIsEditDialogOpen}
        lens={lens}
        form={form}
        onSubmit={handleUpdateLens}
      />
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-1 space-y-6">
          <LensInfoCard lens={lens} />
        </div>
        
        <div className="lg:col-span-2">
          <CompatibleCamerasSection 
            compatibleCameras={compatibleCameras}
            onActionComplete={fetchLensDetails}
          />
        </div>
      </div>
    </div>
  );
}
